import { API } from 'aws-amplify';

export const callRiskScorePrediction = async (input: any): Promise<string> => {
    try {
        const response: any = await API.post('EDPlatformFrontendAPI', '/api/risk-score', {
            body: input,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        console.log('callRiskScorePrediction response', response.response);
        return response.response;
    } catch (err: any) {
        console.error(err)
        console.log("Error when calling callRiskScorePrediction");
        return "";
    }
}
